import "../CheckOutStep.scss";
const PriceSummary = ({ price, discount, total, onNext,nextDisabled }) => {
  return (
    <div className="price-summary">
      <h3>Price Details</h3>

      <div className="price-row">
        <span>Price</span>
        <span>${price}</span>
      </div>

      {discount > 0 && (
        <div className="price-row discount">
          <span>Discount</span>
          <span>- ${discount}</span>
        </div>
      )}

      <div className="divider" />

      <div className="price-total">
        <span>Total</span>
       <strong>${total?.toFixed(2)}</strong>
      </div>

      {onNext && (
        <button className="next-btn" onClick={onNext}  disabled={nextDisabled}>
          Next
        </button>
      )}
    </div>
  );
};

export default PriceSummary;
